import React from "react";

const SettingsIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="settings_icon"
      data-name="settings"
      {...props}
      width={props.width || "20"}
      height={props.height || "20"}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.25008 12.0834C4.93341 12.0834 3.83091 12.9667 3.46925 14.1667H1.66675V15.8334H3.46925C3.83091 17.0334 4.93341 17.9167 6.25008 17.9167C7.56675 17.9167 8.66925 17.0334 9.03091 15.8334H18.3334V14.1667H9.03091C8.66925 12.9667 7.56675 12.0834 6.25008 12.0834ZM6.25008 16.25C5.56091 16.25 5.00008 15.6892 5.00008 15C5.00008 14.3109 5.56091 13.75 6.25008 13.75C6.93925 13.75 7.50008 14.3109 7.50008 15C7.50008 15.6892 6.93925 16.25 6.25008 16.25ZM13.7501 7.08337C12.4334 7.08337 11.3309 7.96671 10.9692 9.16671H1.66675V10.8334H10.9692C11.3309 12.0334 12.4334 12.9167 13.7501 12.9167C15.0667 12.9167 16.1692 12.0334 16.5309 10.8334H18.3334V9.16671H16.5309C16.1692 7.96671 15.0667 7.08337 13.7501 7.08337ZM13.7501 11.25C13.0609 11.25 12.5001 10.6892 12.5001 10C12.5001 9.31087 13.0609 8.75004 13.7501 8.75004C14.4392 8.75004 15.0001 9.31087 15.0001 10C15.0001 10.6892 14.4392 11.25 13.7501 11.25Z"
        fill={props.fill || "#3A8AB9"}
      />
      <path
        d="M10.6976 4.16671C10.3359 2.96671 9.23342 2.08337 7.91675 2.08337C6.60008 2.08337 5.49758 2.96671 5.13591 4.16671H1.66675V5.83337H5.13591C5.49758 7.03337 6.60008 7.91671 7.91675 7.91671C9.23342 7.91671 10.3359 7.03337 10.6976 5.83337H18.4376V4.16671H10.6976ZM7.91675 6.25004C7.22758 6.25004 6.66675 5.68921 6.66675 5.00004C6.66675 4.31087 7.22758 3.75004 7.91675 3.75004C8.60592 3.75004 9.16675 4.31087 9.16675 5.00004C9.16675 5.68921 8.60592 6.25004 7.91675 6.25004Z"
        fill={props.fill || "#3A8AB9"}
      />
    </svg>
  );
};

export default SettingsIcon;
